const UIGlobals =
{
/*****************************************************************************/
ElementType:
{
    STATIC:					0,
    AXIS:					1,
    PLANE_MANIP:			2,
    ROTATE_MANIP:			3,
    ROOM_POINT:				4,
    ROOM_EDGE:				5,
    SIMPLE_AXIS:			6,
    SIMPLE_ROTATE:			7,
    ROOM_OPENING_EDGE:		8,
    ROOM_OPENING_AXIS:		9,
    ROOM_CEILING_EDGE:		10,
    ROOM_CEILING_AXIS:		11,
    ROOM_OPENING_TOPDOWN:   12,
    ROOM_MEASUREMENTS:      13,
	ROOM_OPENING_ROTATE:	14,
	FIXTURE_MEASUREMENTS:	15,
    ROOM_FEATURE: 16
},
/*****************************************************************************/
AxisType:
{
    AXIS_X: 0,
    AXIS_Y: 1,
    AXIS_Z: 2,

    AXIS_X_NEG: 3,
    AXIS_Y_NEG: 4,
    AXIS_Z_NEG: 5,

    AXIS_LAST: 6,
},
/*****************************************************************************/
RoomElementType:
{
	ROOM_OPENING:		0,
	ROOM_WALLS:			1,
	ROOM_FLOOR:			2,
	ROOM_CEILING:		3,
	ROOM_BASEBOARD: 	4,
	ROOM_CROWN: 		5,
	ROOM_CYCLORAMA:		6,
	ROOM_WALL_PANEL:    7,
	ROOM_CHAIR_RAIL:    8,
	ROOM_CEILING_BEAM:  9,
    ROOM_CEILING_ORTH_BEAM:  10,
    ROOM_WALL_PANEL_PROFILE: 11,
},
/*****************************************************************************/
VisibilityStyle:
{
    HIDDEN: 0,
    MINOR: 1,
    MAJOR: 2,
},
/*****************************************************************************/
UIRotateUIType:
{
    SIMPLE_ARROW: 0,
    ANGLED_ELLIPSE: 1,
},
/*****************************************************************************/
CameraClassType:
{
	TOP_DOWN:		0,
	PERSPECTIVE:	1,
	FIRST_PERSON:	2,
},
/*****************************************************************************/
CameraType:
{
	TOP_DOWN_PERSP:	    0,
	TOP_DOWN_ORTHO:	    1,
	PERSPECTIVE:        2,

	// Anything with this index or below is a user camera

	// The user camera is a camera created in Elsie
	USER_CUSTOM:        3,
	// The max camera is a camera brought in from Max
	MAX_CUSTOM:         4,
},
/*****************************************************************************/
// Render type for the given camera, used to determine what parameters to send when
// rendering said camera.
CameraRenderType:
{
	// Invalid cameras, can't be rendered (this is the type for builtins).
	RENDER_INVALID:     0,

	RENDER_PERSPECTIVE:	1,
	RENDER_TOP_DOWN:    2,
	RENDER_360:         3,
	RENDER_BIRDS_EYE:   4,
},
/*****************************************************************************/
OrientationType: 
{
	OrientationCW: 		0,
	OrientationCCW: 	1,
},
/*****************************************************************************/
g_fAxesLengthMult: 1.0 * 0.75,
g_fAxisMulLen: 1.0,
g_strAxisLabelFont: "normal normal 16px Arial",
g_strAxisSmallLabelFont: "normal normal 14px Arial",
g_fSelColorR: 255,
g_fSelColorG: 215,
g_fSelColorB: 0,

g_fRoomEdgeSideOffset: 15,
g_strRoomPointIdPrefix: "roomPoint",
g_strRoomEdgeIdPrefix: "roomEdge",
g_strRoomOpeningEdgeIdPrefix: "openingEdge",
g_strRoomAreaIdPrefix: "area",
/*****************************************************************************/
};

export default UIGlobals;